import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';

import Modal from '../../components/generics/Modal';
import Spinner from '../../components/generics/Spinner';
import DetailHeader from '../../components/generics/DetailHeader';
import SelectableInventoryTable from '../../components/generics/SelectableInventoryTable';

import { fetchInvoice, fetchInvoiceSuccess, fetchInvoiceFailure } from "../../store/invoices/actions";
import { createCreditNote, createCreditNoteSuccess, createCreditNoteFailure } from "../../store/creditNotes/actions";

import { getCreditNoteBoxes } from "../../store/creditNotes/api";

import Alert from '../../utils/Alert';
import { withRouter } from "utils/WithRouter";

export class CreditNoteContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      boxes: [],
      creditNoteNumber: undefined,
      selectedBoxes: [],
      openCreateCreditNoteModal: false
    };

    this.alertRef = React.createRef();
  }

  componentDidMount(){
    const params = queryString.parse(this.props.location.search);
    const selectedInvoice = params.i ? params.i : undefined;
    if (selectedInvoice){
      this.props.fetchInvoice(selectedInvoice);
    }
    // This call its performed outside the redux flow because its only used
    // in the context of this screen.
    getCreditNoteBoxes(selectedInvoice).then((res) => {
      res.data.map((box) => {
        box.old = {price: box.price, number_items: box.number_items, weight: box.weight};
        return true;
      });
      this.setState({ boxes: res.data });
    }, () => {
      this.alertRef.current.sendAlert('Cannot load Invoice boxes');
    });
  }
  // ---------------------------------------------------------------------------
  // Credit Note handling
  // ---------------------------------------------------------------------------
  createCreditNote = () => {
    this.props.createCreditNote({
      invoice: this.props.invoiceDetail.invoice.id,
      data: this.state.selectedBoxes,
      credit_note_number: this.state.creditNoteNumber
    }, this.props, this.alertRef);
  };

  openCreateCreditNoteModal = () => {
    let selected = this.state.boxes.filter((b) => {
      const selected = b.selected;
      delete b.old;
      delete b.in_credit_note;
      return selected;
    });
    if (selected.length === 0) {
      this.alertRef.current.sendAlert("Select at least one inventory item");
    } else {
      this.setState({
        openCreateCreditNoteModal: true,
        selectedBoxes: selected
      });
    }
  };

  onInventorySelect = (event) => {
    const idx = event.target.value;
    let boxes = this.state.boxes;
    const newVal = boxes[idx].selected !== undefined ? !boxes[idx].selected : true;
    if (!newVal){
      boxes[idx].weight = boxes[idx].old.weight;
      boxes[idx].number_items = boxes[idx].old.number_items;
      boxes[idx].price = boxes[idx].old.price;
    }
    boxes[idx].selected = newVal;
    this.setState({ boxes });
  };

  updateWeight = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].weight = newVal;
    this.setState({ boxes });
  };

  updateNumberOfItems = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].number_items = newVal;
    this.setState({ boxes });
  };

  updatePrice = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].price = newVal;
    this.setState({ boxes });
  };

  handleCreditNoteNumberChange = (event) => {
    let creditNoteNumber = event.target.value
    this.setState({ creditNoteNumber })
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
      if (!this.props.invoiceDetail.invoice){
        return (
          <div>
            <Alert ref={this.alertRef}/>
            <Spinner />
          </div>
        );
      } else {
        return (
          <div className="animated fadeIn credit-note">
            <Alert ref={this.alertRef}/>
            <DetailHeader title="Issue Credit Note"
                          actionTitle="Issue"
                          action ={this.openCreateCreditNoteModal}
                          actionClass="btn btn-primary m-0"
                          actionIconClass="fa fa-arrow-right ml-05"
                          col1Title="Invoice Number"
                          col1Desc={this.props.invoiceDetail.invoice.invoice_number}
                          col2Title="Invoice Date"
                          col2Desc={moment(this.props.invoiceDetail.invoice.invoice_date).format('LLL')}
                          col3Title="Vendor"
                          col3Desc={this.props.invoiceDetail.invoice.vendor.name}/>
            <SelectableInventoryTable list={this.state.boxes}
                                      onSelect={this.onInventorySelect}
                                      updateWeight={this.updateWeight}
                                      updateNumberOfItems={this.updateNumberOfItems}
                                      updatePrice={this.updatePrice}
                                      tableTitle="Select the inventory items to include in the credit note"/>
            <Modal
              closeModal={() => this.setState({openCreateCreditNoteModal: false})}
              isModalOpen={this.state.openCreateCreditNoteModal}
              onConfirm={this.createCreditNote}
              onCancel={() => this.setState({openCreateCreditNoteModal: false})}
              header="Create new credit note"
              content="Enter credit note number:"
              textInput = {true}
              message={this.state.creditNoteNumber}
              onMessageChange = {this.handleCreditNoteNumberChange}
              onConfirmButtonText="Continue"
              onCancelButtonText="Cancel"
            />
          </div>
        );
      }
    }
  }

const mapStateToProps = (state, ownProps) => {
  return {
    invoiceDetail: state.invoices.invoiceDetail,
    creditNoteDetail: state.creditNotes.creditNoteDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoice: (id) => {
      dispatch(fetchInvoice(id)).payload.then((response) => {
        dispatch(fetchInvoiceSuccess(response.data))
      }, (error) => {
        dispatch(fetchInvoiceFailure(error));
      });
    },
    createCreditNote: (data, props, alertRef) => {
      dispatch(createCreditNote(data)).payload.then((response) => {
        dispatch(createCreditNoteSuccess(response.data));
        alertRef.current.sendAlert(
          "Credit note successfully issued",
          "success"
        );
        props.history.push(`/credit_note/${response.data.id}`);
      }, (error) => {
        dispatch(createCreditNoteFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreditNoteContainer));
